import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var getCardCss = function getCardCss(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css([".ant-card.ant-card{.ant-card-head{position:relative;&:before{content:'';display:block;position:absolute;left:16px;top:50%;transform:translateY(-50%);width:2px;height:14px;background:", ";}}.ant-card-actions > li > span a:hover{color:", ";}}"], primary6, primary6);
};
export default getCardCss;